import React from 'react';

export default function CheckError(props) {
    const {color = '#F55A5A', height = '20', width = '20'} = props;
    return (
        <svg width={width} height={height} viewBox='0 0 20 20' {...props}>
            <g fill='none' fillRule='nonzero'>
                <path fill={color} d='M10 16.47a6.47 6.47 0 1 0 0-12.94 6.47 6.47 0 0 0 0 12.94z' />
                <path fill='#FFF' d='M9.412 6.47l1.176.004v4.702H9.412V6.471zm0 5.883h1.176v1.176H9.412v-1.176z' />
            </g>
        </svg>
    );
}
